import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CardsService, DigitalCard } from 'src/app/services/cards.service';
import * as QRCode from 'qrcode';
import { environment } from 'src/environments/environment';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MaterialModule } from 'src/app/shared/material.module';
import { CommonModule } from '@angular/common';
import html2canvas from 'html2canvas'; // ✅ Proper import
import { BreadcrumbComponent } from 'src/app/components/shared/breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-download-page',
  standalone: true,
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.scss'],
  imports: [
    CommonModule,
    MaterialModule,
    MatProgressSpinnerModule,
    BreadcrumbComponent,
  ],
})
export class DownloadComponent implements OnInit, AfterViewInit {
  @ViewChild('qrCanvas') qrCanvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('qrSectionWrapper') qrSectionWrapper!: ElementRef<HTMLDivElement>;

  card: DigitalCard | null = null;
  cardImageUrl: string | null = null;
  qrLoading = true;
  environment = environment;
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cardsService: CardsService
  ) {}

  ngOnInit(): void {
    const cardId = this.route.snapshot.paramMap.get('id');
    if (!cardId) return;
    this.loadCardData(cardId);
  }

  ngAfterViewInit() {
    if (this.card) {
      this.generateQrCode();
    }
  }

  async loadCardData(cardId: string) {
    this.qrLoading = true;
    try {
      this.card = this.cardsService.cards().find(c => c.id === cardId) || null;
      if (!this.card) {
        console.error('Card not found in state');
        return;
      }

      this.cardImageUrl = this.card.seoImage ?? (await this.cardsService.getCardImage(cardId))?.url ?? null;

      setTimeout(() => this.generateQrCode(), 0);
    } catch (error) {
      console.error('Error loading card:', error);
    }
  }

  private async generateQrCode() {
  if (!this.qrCanvas || !this.card) return;
  this.qrLoading = true;
  try {
    await QRCode.toCanvas(this.qrCanvas.nativeElement, `${environment.appUrl}/${this.card.handler}`, {
      width: 220,
      color: {
        dark: '#000000',
        light: '#ffffff00' // ✅ transparent background
      }
    });
  } catch (err) {
    console.error('QR generation failed', err);
  } finally {
    this.qrLoading = false;
  }
}


  // ✅ FIXED: use actual html2canvas and correct return type
async downloadQrSection() {
  if (!this.qrSectionWrapper) return;

  try {
    const canvas = await html2canvas(this.qrSectionWrapper.nativeElement, {
      backgroundColor: null, // preserve the purple background
      scale: 2,
    });

    const link = document.createElement('a');
    link.href = canvas.toDataURL('image/png');
    link.download = `${this.card?.handler || 'qr-section'}.png`;
    link.click();
  } catch (err) {
    console.error('Failed to download QR section', err);
  }
}

  downloadCard() {
    if (!this.cardImageUrl) return;
    const link = document.createElement('a');
    link.href = this.cardImageUrl;
    link.download = `${this.card?.handler || 'digital-card'}.png`;
    link.click();
  }

  goBack() {
    this.router.navigate(['/cards']);
  }

  copyHandlerLink() {
    if (!this.card?.handler) return;
    const link = `${environment.appUrl}/${this.card.handler}`;
    navigator.clipboard.writeText(link).then(() => alert('Link copied to clipboard!'));
  }

  async shareHandlerLink() {
    if (!this.card?.handler) return;
    const link = `${environment.appUrl}/${this.card.handler}`;
    if (navigator.share) {
      try {
        await navigator.share({
          title: this.card.business_info?.businessName || 'Digital Card',
          text: 'Check out this card',
          url: link,
        });
      } catch (err) {
        console.error(err);
      }
    } else {
      alert(`Share this link: ${link}`);
    }
  }

  formatPhone(phone?: string): string {
    if (!phone) return '-';
    return phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  }
}